// extracted by mini-css-extract-plugin
export default {"one1":"Resume2_one1__eVj7G","icons":"Resume2_icons__mip93","gridContainer":"Resume2_gridContainer__RCrgB","resume":"Resume2_resume__bSi2M"};